import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import DataTable from "datatables.net-bs5"

// Table of cycles selected for the collective report. Rows can be reordered
// by dragging or by sorting a column; the order is saved to the session
// because the report uses it.
export default class extends Controller {
  static targets = ["table", "body"]
  static values = { reorderUrl: String }

  connect() {
    this.dataTable = new DataTable(this.tableTarget, {
      responsive: true,
      columnDefs: [{ targets: "no-sort", orderable: false }],
      order: [],
      paging: false,
      searching: false,
      info: false,
      language: { emptyTable: "Brak danych" }
    })
    // "order" fires before the redraw, so read the order from DataTables
    // rather than from the DOM.
    this.dataTable.on("order", () => {
      const rows = this.dataTable.rows({ order: "current" }).nodes().toArray()
      this.saveOrder(rows)
    })

    // A row removed by a turbo_stream "remove" has to leave DataTables too,
    // or it comes back on the next sort.
    this.removeRow = (event) => {
      const row = this.bodyTarget.querySelector(`#${event.target.target}`)
      if (event.target.action === "remove" && row) {
        event.detail.render = () => this.dataTable.row(row).remove().draw(false)
      }
    }
    document.addEventListener("turbo:before-stream-render", this.removeRow)

    this.sortable = Sortable.create(this.bodyTarget, {
      animation: 150,
      ghostClass: "bg-light",
      onEnd: () => this.saveOrder(Array.from(this.bodyTarget.querySelectorAll("tr[data-id]")))
    })
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.removeRow)
    this.sortable?.destroy()
    this.dataTable?.destroy()
  }

  saveOrder(rows) {
    const body = new FormData()
    rows.forEach((row) => {
      if (row.dataset.id) body.append("ordered_ids[]", row.dataset.id)
    })

    fetch(this.reorderUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content },
      body
    })
  }
}
